import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, ChevronRight, Gift, Star } from 'lucide-react';
import { AppContext } from './AppContext';
import './NewLuxurySection.css';

const NewLuxurySection = () => {
  const navigate = useNavigate();
  const { t } = useContext(AppContext);

  return (
    <section className="luxury-highlights-section">
      {/* 1st Screenshot Concept: Tanishq style twin promo banner with animated ribbon glow */}
      <div className="tanishq-promo-grid">
        <motion.div
          className="promo-card red-theme"
          whileHover={{ y: -6, scale: 1.01 }}
          transition={{ duration: 0.4 }}
          onClick={() => navigate('/gifting/silver-idols')}
        >
          <div className="gift-ribbon-tag"><Gift size={14} /> {t.luxurySpecialGiftBox}</div>
          <div className="promo-img-wrap">
            <img src="images/painjan10.jpg" alt="Silver Idols & Artefacts" />
          </div>
          <div className="promo-caption">
            <span className="promo-badge"><Sparkles size={12} /> {t.luxuryPure925}</span>
            <h3>{t.luxurySilverIdols}</h3>
            <p>{t.luxurySilverIdolsDesc}</p>
            <span className="promo-link">{t.luxuryExploreCollection} <ArrowRight size={14} /></span>
          </div>
        </motion.div>

        <motion.div
          className="promo-card gold-theme"
          whileHover={{ y: -6, scale: 1.01 }}
          transition={{ duration: 0.4 }}
          onClick={() => navigate('/products?category=For+Women&subcategory=Chains')}
        >
          <div className="gift-ribbon-tag gold"><Star size={14} /> {t.luxuryNewLaunch}</div>
          <div className="promo-img-wrap">
            <img src="images/w chain14.jpg" alt="Station Mangalsutra" />
          </div>
          <div className="promo-caption">
            <span className="promo-badge">{t.luxuryNewArrival}</span>
            <h3>{t.luxuryMangalsutra}</h3>
            <p>{t.luxuryMangalsutraDesc}</p>
            <span className="promo-link">{t.luxuryShopNewArrivals} <ArrowRight size={14} /></span>
          </div>
        </motion.div>
      </div>

      {/* 2nd Screenshot Concept Redesigned: Indriya style luxury gifting banner with Her, Him, Kids Gifting boxes */}
      <div className="indriya-gift-banner">
        <div className="indriya-ribbon-cross"></div>
        <div className="indriya-left-box">
          <div className="indriya-frame">
            <span className="indriya-sub">{t.luxuryGdrSignatureEdit}</span>
            <h2>{t.luxuryGiftsSparkle}</h2>
            <p>{t.luxuryGiftsDesc}</p>
            <button
              className="btn-indriya-explore"
              onClick={() => navigate('/gifting')}
            >
              {t.luxuryExploreGifting} <ChevronRight size={16} />
            </button>
          </div>
        </div>

        {/* Her, Him, Kids Gifting boxes with jewellery images */}
        <div className="indriya-gifting-boxes-row">
          <div className="gifting-box-card" onClick={() => navigate('/gifting/for-her')}>
            <div className="box-card-ribbon">🎁</div>
            <img src="images/w ring1.jpg" alt="For Her" />
            <div className="box-card-caption">
              <h4>{t.luxuryForHer}</h4>
              <span>{t.luxuryForHerDesc}</span>
            </div>
          </div>

          <div className="gifting-box-card" onClick={() => navigate('/gifting/for-him')}>
            <div className="box-card-ribbon">🎁</div>
            <img src="images/men br6.jpg" alt="For Him" />
            <div className="box-card-caption">
              <h4>{t.luxuryForHim}</h4>
              <span>{t.luxuryForHimDesc}</span>
            </div>
          </div>

          <div className="gifting-box-card" onClick={() => navigate('/gifting/for-baby')}>
            <div className="box-card-ribbon">🎁</div>
            <img src="images/painjan5.jpg" alt="For Kids" />
            <div className="box-card-caption">
              <h4>{t.luxuryForKids}</h4>
              <span>{t.luxuryForKidsDesc}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewLuxurySection;
